import { Source } from "pmt-types/src/models/Source.ts";
import { useQuery } from "react-query";
import { Maybe } from "../../utils/types/maybe.ts";
import { useAuthentication } from "../useAuthentication.ts";
import { QueryKeys } from "./queryKeys.ts";

export const useQueryGetSourceById = (sourceId: Maybe<string>) => {
  const { accessToken } = useAuthentication();

  return useQuery(
    [QueryKeys.GetSource, sourceId],
    async () => {
      const response = await fetch(
        `${import.meta.env.VITE_API_HOST}/sources/${sourceId}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            authorization: accessToken ?? "",
          },
        },
      );

      if (!response.ok) {
        throw new Error("Failed to query source");
      }

      return (await response.json()) as Source;
    },
    {
      staleTime: 15 * 60 * 1000, // 15 minutes
      enabled: sourceId != null && sourceId != "new",
      onError: (error) => {
        console.error("Failed to get source", error, sourceId);
      },
    },
  );
};
